(function () {
  'use strict';

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function start() {
    var root = document.querySelector('[data-idp-encyclopedia-hub]');
    if (!root) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-idp-encyclopedia-card]'));
    var search = root.querySelector('[data-idp-encyclopedia-search]');
    var family = root.querySelector('[data-idp-encyclopedia-family]');
    var reset = root.querySelector('[data-idp-encyclopedia-reset]');
    var visible = root.querySelector('[data-idp-encyclopedia-visible]');
    var empty = root.querySelector('[data-idp-encyclopedia-empty]');
    if (!search || !family || !reset || !visible || !empty) return;

    var params = new URLSearchParams(window.location.search);
    search.value = params.get('q') || '';
    family.value = params.get('familia') || '';

    function applyFilters() {
      var term = normalize(search.value);
      var selectedFamily = normalize(family.value);
      var shown = 0;

      cards.forEach(function (card) {
        var matchesSearch = !term || normalize(card.dataset.searchIndex).indexOf(term) !== -1;
        var matchesFamily = !selectedFamily || normalize(card.dataset.family) === selectedFamily;
        var matches = matchesSearch && matchesFamily;
        card.hidden = !matches;
        if (matches) shown += 1;
      });

      visible.textContent = String(shown);
      empty.hidden = shown !== 0;

      var next = new URLSearchParams();
      if (search.value.trim()) next.set('q', search.value.trim());
      if (family.value) next.set('familia', family.value);
      history.replaceState(null, '', window.location.pathname + (next.toString() ? '?' + next.toString() : ''));
    }

    search.addEventListener('input', applyFilters);
    family.addEventListener('change', applyFilters);
    reset.addEventListener('click', function () {
      search.value = '';
      family.value = '';
      applyFilters();
      search.focus();
    });
    applyFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
